import * as yup from 'yup';
import { versicherungsnehmerSchema as versicherungsnehmerSchemaBase } from '@/features/Sparten/shared/schema/kfz/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { useKradv2InputStore } from '@/features/Sparten/kradv2/useInputStore';
import { ROLE, useClient } from '@/features/Clients';
import { getDifference } from '@/utils/dates/dates';
import { isWkz003 } from '@/features/Sparten/kradv2/renderConditions';

const validateFuehrerscheinDatum = (val: Date | null | undefined): boolean => {
  if (useKradv2InputStore().versicherungsnehmer.isFirma) return true; // no need for companies

  if (val === null || val === undefined) return false;

  const { client } = useClient(ROLE.VERSICHERUNGSNEHMER);

  if (client.value === undefined) return false;

  if (client.value.data.geburtsdatum === null) return false;

  let minAge = 16;

  if (isWkz003.value) {
    minAge = 18;
  }

  return getDifference(val, client.value.data.geburtsdatum, true) >= minAge;
};

export const versicherungsnehmerSchema = versicherungsnehmerSchemaBase.concat(
  yup.object({
    anSicherheitstrainingTeilnahmedatum: yup.date().nullable().default(null),
    hasPunkteInFlensburg: yup.boolean().default(false),
    fuehrerscheindatum: yup
      .date()
      .default(null)
      .nullable()
      .when(['isFirma', 'isFullAge'], {
        is: (val: boolean, isFullAge: boolean) => !val && !isFullAge,
        then: yup
          .date()
          .required()
          .test({
            name: 'isOldEnough',
            message() {
              let message =
                'Fahrer muss beim Führerscheinerwerb mindestens 16 Jahre alt sein.';

              if (isWkz003.value) {
                message =
                  'Fahrer muss beim Führerscheinerwerb mindestens 18 Jahre alt sein.';
              }

              return message;
            },
            test: validateFuehrerscheinDatum,
          }),
      }),
  }),
);
